import { Route } from "@angular/router";

export const ProductPaths = {
  GroupPersonProductList: (productGroupId: number | string) => `groep/${productGroupId}/besteld`,
};
export default [
  {
    path: ProductPaths.GroupPersonProductList(":productGroupId"),
    loadComponent: () =>
      import("./pages/person-product-list/person-product-list.component").then(
        (c) => c.PersonProductListComponent
      ),
    data: {
      breadcrumb: "producten",
      title: "Bestelde producten",
    },
  },
] satisfies Route[];
